import { ListboxDesignTokens } from '@primeuix/themes/types/listbox';

import { getRem } from '@customer-portal/shared/helpers/theme-utils';

export const listBoxOverride: ListboxDesignTokens = {
  root: {
    borderRadius: getRem(10),
    shadow: 'none',
  },
  list: {
    padding: `${getRem(4)} ${getRem(0)}`,
    gap: getRem(2),
    header: {
      padding: `${getRem(14)} ${getRem(17.5)} ${getRem(10.5)} ${getRem(14)}`,
    },
  },
  option: {
    padding: `${getRem(6)} ${getRem(12)}`,
    borderRadius: '0',
  },
  emptyMessage: {
    padding: `${getRem(6)} ${getRem(12)}`,
  },
  checkmark: {
    gutterStart: getRem(4),
    gutterEnd: getRem(8),
  },
};
